import {
    apiRequest,
    organizationCreate,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/organizationhistoriService"

class CreateRepository {

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", organizationCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository